export default {
  productName: 'Quick Wraps',
  pathId: 'fightcamp-quick-wraps',
  description: 'These wraps secure your Trackers, add knuckle padding, and support your wrists — all in one sleek, sweat-wicking design. ',
  shortDescription: 'Wrap. Track. Protect.',
  isSoldOut: false,
  primaryImg: {
    src: 'https://a.storyblok.com/f/152150/800x800/9a1ba3f227/quickwraps.jpg',
    alt: 'FightCamp quick wraps',
  },
  lifestyleImage: {
    src: 'https://a.storyblok.com/f/152150/352x352/5bc6c1c45e/fc-quickwraps-thumbnail-001.png',
    alt: 'FightCamp quick wraps',
  },
  includesModalCopy: {},
  assets: [],
  features: [
    {
      title: 'Features',
      copy: [
        'Secure pocket for punch trackers',
        'Wrist wrap with velcro attachment',
        'Padding on knuckles',
      ],
    },
    {
      title: 'Size & Fit',
      copy: [
        'Available in S/M and L/XL',
        "L/XL is typically best for individuals taller than 5'9",
        'Stretchable fabric ensures a snug, adaptive fit',
      ],
    },
    {
      title: 'Materials & Care',
      copy: [
        'Made from 80% polyester, 20% spandex',
        'Machine washable (cold wash) and tumble dry low',
      ],
    },
  ],
};
